/* SpinRPM landing: Halo ticks, sticky links, scroll reveals, Halo sweep, step rails, photo drift.
   Motion is skipped when the visitor prefers reduced motion; the page is complete without it. */
(function () {
  var root = document.getElementById('spinrpm');
  if (!root) return;

  /* Draw the Halo tick ring (0–240 RPM over 270°, every 8th tick major). Static, so it always runs. */
  root.querySelectorAll('[data-sr-halo]').forEach(function (svg) {
    var g = svg.querySelector('.sr-halo__ticks');
    var value = parseFloat(svg.getAttribute('data-value')) || 0;
    var ticks = 40, R = 88, c = 90, ns = 'http://www.w3.org/2000/svg';
    for (var i = 0; i <= ticks; i++) {
      var v = 240 * i / ticks;
      var a = (225 - 270 * v / 240) * Math.PI / 180;
      var r1 = R * (i % 8 === 0 ? 0.86 : 0.91);
      var line = document.createElementNS(ns, 'line');
      line.setAttribute('x1', (c + r1 * Math.cos(a)).toFixed(1));
      line.setAttribute('y1', (c - r1 * Math.sin(a)).toFixed(1));
      line.setAttribute('x2', (c + R * Math.cos(a)).toFixed(1));
      line.setAttribute('y2', (c - R * Math.sin(a)).toFixed(1));
      if (v <= value) line.setAttribute('class', 'is-lit');
      g.appendChild(line);
    }
  });

  /* Keep the section links below the store header when that header is sticky. */
  function placeSubnav() {
    var header = document.querySelector('#header-group .header-section') || document.querySelector('#header-group > *');
    var top = 0;
    if (header) {
      var pos = getComputedStyle(header).position;
      if (pos === 'sticky' || pos === 'fixed') top = header.getBoundingClientRect().height;
    }
    root.style.setProperty('--sr-sticky-top', top + 'px');
  }
  placeSubnav();
  window.addEventListener('resize', placeSubnav);

  /* Highlight the current section in the sticky links. */
  var links = root.querySelectorAll('.sr-subnav__links a');
  if ('IntersectionObserver' in window && links.length) {
    var byId = {};
    links.forEach(function (a) { byId[a.getAttribute('href').slice(1)] = a; });
    var nav = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        links.forEach(function (a) { a.classList.remove('is-active'); });
        if (byId[e.target.id]) byId[e.target.id].classList.add('is-active');
      });
    }, { rootMargin: '-45% 0px -50% 0px' });
    Object.keys(byId).forEach(function (id) { var el = document.getElementById(id); if (el) nav.observe(el); });
  }

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduce.matches || !('IntersectionObserver' in window)) return;
  root.classList.add('is-motion');

  var once = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      once.unobserve(e.target);
      var count = e.target.querySelector('[data-sr-count]');
      if (count) countUp(count);
    });
  }, { threshold: 0.2 });
  root.querySelectorAll('.sr-reveal, [data-sr-steps]').forEach(function (el) { once.observe(el); });

  function countUp(el) {
    var target = parseFloat(el.getAttribute('data-sr-count'));
    var start = performance.now(), duration = 1100;
    function tick(now) {
      var t = Math.min(1, (now - start) / duration);
      el.textContent = Math.round(target * (1 - Math.pow(1 - t, 3)));
      if (t < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  /* Background photos drift at 0.9x scroll speed. */
  var drifts = root.querySelectorAll('[data-sr-drift]');
  var ticking = false;
  function drift() {
    ticking = false;
    drifts.forEach(function (img) {
      var box = img.parentElement.getBoundingClientRect();
      if (box.bottom < 0 || box.top > window.innerHeight) return;
      img.style.transform = 'translateY(' + (-box.top * 0.1).toFixed(1) + 'px)';
    });
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; requestAnimationFrame(drift); }
  }, { passive: true });

  reduce.addEventListener && reduce.addEventListener('change', function (e) {
    if (!e.matches) return;
    root.classList.remove('is-motion');
    drifts.forEach(function (img) { img.style.transform = ''; });
  });
})();
